export default "__VITE_ASSET__50cadad1__"